export const ASSISTED_PROGRESS_ATTEMPT_THRESHOLD = 1;

interface AssistedProgressParams {
  attemptCount: number;
  resolved: boolean;
  fullHintRevealed?: boolean;
}

export function canOfferAssistedProgress(params: AssistedProgressParams): boolean {
  const {
    attemptCount,
    resolved,
    fullHintRevealed = true,
  } = params;

  return !resolved
    && fullHintRevealed
    && Number.isFinite(attemptCount)
    && attemptCount >= ASSISTED_PROGRESS_ATTEMPT_THRESHOLD;
}
